import template from './main.html';
import controller from './main.controller.js';

const dashboardMainComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default dashboardMainComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/main/main.component.js
 **/